import React from 'react';

import './delete_popup.css'


const DeleteConfirmation = ({ isOpen, onClose, onConfirm }) => {
    return (
      <>
        {isOpen && (
          <div className="delete-popup-overlay">
            <div className="delete-popup-content">
              <span onClick={onClose} className="delete-popup-close">
                &times;
              </span>
              <div className='delete-popup-page'>
                <div className='delete-title'>
                  <h3>Möchten Sie diesen Datensatz wirklich löschen?</h3>
                </div>
                <div className='confirm-delete-cancel'>
                  <button onClick={onClose}>ABBRECHEN</button>
                  <button onClick={onConfirm}>LÖSCHEN</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };
  
  export default DeleteConfirmation;